@if (expanded) {
<div class="assign_expand_container" [@expandCollapse]>
  <div class="expand_content">
    <div class="expand_body">
      <div class="assign_section">
        <div class="assign_select_wrap" #assignSelectWrap>
        <ng-select
         #assigneeSelect
         [items]="ngSelectItems()"
          bindLabel="name"
          bindValue="_id"
          [ngModel]="selectedUserIds()"
          (ngModelChange)="onUserSelectionChange($event)"
          (add)="onAssigneeAdd()"
          (remove)="onAssigneeRemove()"
          (selectionChanges)="onAssigneeSelectionChanges()"
          (select)="onAssigneeSelect()"
          (change)="onAssigneeChange()"
          [multiple]="true"
          [searchable]="true"
          [clearable]="false"
          [closeOnSelect]="false"
          [hideSelected]="true"
          [loading]="isLoadingData"
          [placeholder]="isLoadingData ? expandConfig().loadingText : expandConfig().placeholder"
          (search)="onAssigneeSearch($event)"
          (blur)="onAssigneeBlur($event)"
          (open)="onAssigneeOpen()"
          (close)="onAssigneeDropdownClose()"
          [ngClass]="{'has-tooltip': selectedUsers().length > 2}"
          [title]="selectedUsers().length > 2 ? selectedUsers().map(getDisplayName).join(', ') : ''"
          [appendTo]="'body'"
          panelClass="assignee-expand-dropdown-panel"
          [dropdownPosition]="'bottom'"
          class="assign_select expand-ng-select">
          <ng-template ng-option-tmp let-item="item">
            <div class="assignee-expand-option" (mouseenter)="clearNativeOptionTitle($event)">
              <div class="assignee-expand-option__avatar" [class.has-image]="hasValidImage(item)">
                @if (hasValidImage(item)) {
                <img 
                  [src]="item.image || item.avatar" 
                  [alt]="getDisplayName(item)"
                  (error)="onImageError(item._id)"
                  class="assignee-expand-option__img" />
                }
                @if (!hasValidImage(item)) {
                <div 
                  class="assignee-expand-option__placeholder"
                  [style.background-color]="getAvatarColor(item._id)">
                  {{ getInitials(getDisplayName(item)) }}
                </div>
                }
              </div>
              <span
                class="assignee-expand-option__name"
                [appCopyableTruncateTooltip]="getDisplayName(item)"
                [appCopyableTruncateKeepOnInteract]="true">{{ getDisplayName(item) }}</span>
            </div>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <div class="assignee-expand-option__empty">
              <mat-icon>search_off</mat-icon>
              <p>{{ expandConfig().noResultsText }}</p>
            </div>
          </ng-template>
        </ng-select>
        @if (!isLoadingData && !assigneeSearch().trim()) {
          <span class="assign_select_custom_placeholder" aria-hidden="true">
            {{ expandConfig().placeholder }}
          </span>
        }
        @if (isLoadingData) {
          <span class="assign_select_custom_placeholder assign_select_custom_placeholder--loading" aria-hidden="true">
            {{ expandConfig().loadingText }}
          </span>
        }
        </div>
      </div>
      
      @if (selectedUsers().length > 0) {
      <div class="assign_selected">
        <label class="assign_label">Selected Assignees ({{ selectedUsers().length }})</label>
        <div class="assign_selected_list">
          @for (user of selectedUsers(); track user._id; let i = $index) {
          <div class="assign_selected_item">
            <div class="assign_avatar" [class.has-image]="hasValidImage(user)">
              @if (hasValidImage(user)) {
              <img 
                [src]="user.image || user.avatar" 
                [alt]="getDisplayName(user)"
                (error)="onImageError(user._id)"
                class="avatar-image" />
              }
              @if (!hasValidImage(user)) {
              <div 
                class="avatar-placeholder"
                [style.background-color]="getAvatarColor(user._id)">
                {{ getInitials(getDisplayName(user)) }}
              </div>
              }
            </div>
            <div class="assignee-info">
              <span
                class="assignee-name"
                [appCopyableTruncateTooltip]="getDisplayName(user)">{{ getDisplayName(user) }}</span>
            </div>
            <button class="assign_remove_btn" (click)="removeSelectedUser(i)" title="Remove user" type="button">
             <mat-icon>close</mat-icon>
            </button>
          </div>
          }
        </div>
      </div>
      }
      
      <!-- No Changes Message -->
       @if (showNoChangesMessage()) {
      <div class="no-changes-message">
        <div class="message-content">
          <mat-icon class="message-icon">info</mat-icon>
          <span class="message-text">{{ expandConfig().noChangesMessage }}</span>
        </div>
      </div>
      }
    </div>
    
    <div class="expand_actions">
      <button class="btn-save" (click)="onAssignUsersClick()" [disabled]="selectedUsers().length === 0" type="button">
        {{ expandConfig().confirmText }}
      </button>
      <button class="btn-cancel" (click)="collapsePanel()" type="button">{{ expandConfig().cancelText }}</button>
    </div>
  </div>
</div>
}

<app-confirm-popup
  [show]="showAssignConfirmPopup()"
  [appendToBody]="true"
  [config]="{
    title: 'Assign Users',
    message: 'Are you sure you want to assign the selected users?',
    type: 'info',
    showCancel: true,
    cancelText: 'Cancel',
    confirmText: 'Assign',
    loading: isAssigningUsers()
  }"
  (confirm)="confirmAssignUsers()"
  (cancel)="cancelAssignUsers()"
></app-confirm-popup>

